// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".flag.xs[data-v-63611c7f]{height:1rem;width:1rem}.flag.sm[data-v-63611c7f]{height:1.25rem;width:1.25rem}.flag.md[data-v-63611c7f]{height:2rem;width:2rem}.flag.lg[data-v-63611c7f]{height:3rem;width:3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
